<template>
<v-card width="600" class="mx-auto mt-5">
  <v-card-title>
    <h1 class="display-1">Set Pace</h1>
  </v-card-title>
  <v-card-text>
    <v-form>
      <v-slider
      v-model="time.value"
      :label="time.label"
      :thumb-color="time.color"
      thumb-size="64"
      min="180"
      max="1200"
      step="5"
      ></v-slider>

    </v-form>
    <h2>Pace: {{pace}}</h2>
  </v-card-text>
  <v-divider></v-divider>
  <v-list two-line>
    <v-list-item-group v-for="(race, index) in races" :key="race.id">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{ race.title }}</v-list-item-title>
          <v-list-item-subtitle class="text--primary">{{race.subtitle}}</v-list-item-subtitle>
          <v-list-item-subtitle></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-list-item-title>{{ finish(race.distance, time.value) }}</v-list-item-title>
        </v-list-item-action>
      </v-list-item>
      <v-divider
        v-if="index + 1 < races.length"
        :key="index"
      >
      </v-divider>
    </v-list-item-group>
    </v-list>
</v-card>
</template>

<script>
import { pad, floor } from '../helpers';

export default {
  name: 'PaceCalculator',
  props: {

  },
  data() {
    return {
      time: { label: 'Pace', value: 540, color: 'red' },
      races: [
        { id: 1, distance: 13.1, title: 'Half Marathon', subtitle: '13.1 Miles' },
        { id: 2, distance: 26.2, title: 'Full Marathon', subtitle: '26.2 Miles' },
        { id: 3, distance: 31.1, title: '50K', subtitle: '50 Kilometers (31.1 Miles)' },
        { id: 4, distance: 40, title: '40 Miler', subtitle: '40 Miles' },
        { id: 5, distance: 50, title: '50 Miler', subtitle: '50 miles' },
        { id: 6, distance: 100, title: '100 Miles', subtitle: 'One Hundred Miles' },
      ],
    };
  },
  computed: {
    pace: function () {
      const time = this.time.value;
      const minutes = floor(time / 60);
      let seconds = (time % 60);
      seconds = pad(seconds);
      const pace = `${minutes}:${seconds}`;
      return pace;
    },
  },
  methods: {
    finish: function (distance, time) {
      const totalseconds = distance * time;
      const hours = floor(totalseconds / 3600);
      const minutes =  pad(floor((totalseconds  % 3600) / 60));
      const seconds = pad(floor(totalseconds % 60));
      const finish = `${hours}:${minutes}:${seconds}`;
      return finish;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
